import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';
import LoginForm from '../components/LoginForm';
import { useLoading } from '../../../contexts/LoadingContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const { user, login } = useAuth();
  const { loading, setLoading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    // console.log('use effect')
    if (user) {
      navigate('/');
      // navigate('/permissions');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    setLoading(true);
    console.log('e', e);
    e.preventDefault();

    setErrors({});

    try {
      const isLoggedin = await login(email, password);
      console.log('islog', isLoggedin);
      if (isLoggedin) {
        // showSuccessToast("Login successful!");
        //  navigate("/");
        navigate('/permissions');
      }
      setLoading(false);
    } catch (error) {
      console.log('errr', error);
      // setErrors({ general: "Login failed. Please check your credentials." });
      showErrorToast(error.message || 'An unexpected error occurred.');
      setLoading(false);
    }
  };
  if (user) {
    return null; //return loading component here in future
  }
  return (
    <div>
      <section id="login">
        <div className="left">
          <span>
            <img src="images/s&flogo.svg" alt="Logo" />
          </span>
        </div>
        <div className="right">
          <LoginForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            handleSubmit={handleSubmit}
            errors={errors}
            loading={loading}
          />
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
